import { ObjectField, Int32Field, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class TubularLfo extends ObjectField {
    static create(construct) {
        return new TubularLfo(construct);
    }
    constructor(construct) {
        super(construct);
    }
    get speed() {
        return this.getField(1);
    }
    get delay() {
        return this.getField(2);
    }
    get pmDepth() {
        return this.getField(3);
    }
    get amDepth() {
        return this.getField(4);
    }
    get sync() {
        return this.getField(5);
    }
    get wave() {
        return this.getField(6);
    }
    initializeFields() {
        return {
            1: Int32Field.create({
                parent: this,
                fieldKey: 1,
                fieldName: "speed",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99 }, "", 35),
            2: Int32Field.create({
                parent: this,
                fieldKey: 2,
                fieldName: "delay",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99 }, "", 0),
            3: Int32Field.create({
                parent: this,
                fieldKey: 3,
                fieldName: "pmDepth",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99 }, "", 0),
            4: Int32Field.create({
                parent: this,
                fieldKey: 4,
                fieldName: "amDepth",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99 }, "", 0),
            5: Int32Field.create({
                parent: this,
                fieldKey: 5,
                fieldName: "sync",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 1 }, "", 1),
            6: Int32Field.create({
                parent: this,
                fieldKey: 6,
                fieldName: "wave",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 5 }, "", 0),
        };
    }
}
